// extracted by mini-css-extract-plugin
export default {"section":"Hr-z","inSectionButton":"Ir-z","addressCard":"Jr-z","disabled":"Kr-z","cautionBox":"Lr-z","failureBox":"Mr-z","fade-out":"Nr-z","successBox":"Or-z"};